/* eslint-disable no-undef */
(function (root, factory) {
    if (typeof module === 'object' && module.exports) {
        module.exports = factory(
            require('backbone'),
            require('lodash'),
            require('../utils/fp_utils'),
        );
    } else if (typeof define === 'function' && define.amd) {
        define(['backbone', 'lodash', '../utils/fp_utils'], factory);
    }
})(this, function (Backbone, _, fpUtils) {
    'use strict';

    function _listPlugins() {
        return _.map(navigator.plugins, function (plugin) {
            return plugin.name;
        }).join('::');
    }

    function _listMimeTypes() {
        return _.map(navigator.mimeTypes, function (mimeType) {
            return mimeType.type;
        }).join('::');
    }

    function _hasLocalStorage() {
        try {
            return !!window.localStorage;
        } catch (e) {
            // If a security error occurs, localStorage is available
            return true;
        }
    }

    function _hasSessionStorage() {
        try {
            return !!window.sessionStorage;
        } catch (e) {
            // If a security error occurs, sessionStorage is available
            return true;
        }
    }

    function _isTouchDevice() {
        return 'ontouchstart' in window || navigator.maxTouchPoints;
    }

    /**
     * Gather Features of the browser.
     */

    return Backbone.Model.extend({
        getFeatures: function () {
            return [
                navigator.language,
                fpUtils.pack('HHHB', [
                    fpUtils.fnv16a(_listPlugins()),
                    fpUtils.fnv16a(_listMimeTypes()),
                    fpUtils.fnv16a((navigator.languages || []).join('|')),
                    (navigator.javaEnabled() << 0) |
                        (navigator.cookieEnabled << 1) |
                        (_hasLocalStorage() << 2) |
                        (_hasSessionStorage() << 3) |
                        (_isTouchDevice() << 4) |
                        (!!navigator.connection << 5) |
                        (!!navigator.permissions << 6) |
                        0,
                ]),
            ];
        },
    });
});
